import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const ReceiptIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        data-name="Icon HourGlass"
        d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z"
        transform="translate(-3.375 -3.375)"
      />
    </Icon>
  );
};

export default ReceiptIcon;
